import { createTheme } from "@mui/material";
import { ReadonlyURLSearchParams } from "next/navigation";
import { LANGTYPE_EN, LANGCODE_EN, LANGCODE_CT, LangCode } from "./LanguageContext";
import { getFOStage } from "@/app/utils/request/requestList";
import { formattedDate } from "./DayJS";
import { getMetaTitle } from "./Metadata";

export const theme = createTheme({
    components: {
      // Name of the component
      MuiButtonBase: {
        defaultProps: {
          // The props to change the default for.
          disableRipple: true, // No more ripple, on the whole application 💣!
        },
      },
      MuiLink: {
        defaultProps: {
          underline: "hover",
          color: "#122C68"
        }
      }
    },
    typography: {
       fontFamily: "inherit",
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1024,
        xl: 1536, 
      },
    },
    palette: {
      primary: {
        main: "#173E96",
        light: "#E2EDF6",
        dark: "#132B68",
      },
      grey: {
        100: "#F4F4F4",
        300: "#E1E1E1",
      },
      text: {
        primary: "#000000",
        secondary: "#333333",
      },
      divider: "#B4B4B4",
    },
  });
  
export function redirectPage(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, action: string, lang: string) {
    e.preventDefault();
    let url = "";
    if (typeof window !== "undefined" && window.top !== null) {
      let returnURL = window.top.location.href;
      if (typeof returnURL !== "undefined") {
        returnURL = encodeURIComponent(returnURL);
        if(lang === LANGTYPE_EN){
          if (action == "login") {
            url = window.globalConfig?.LINKED_PAGES?.LOGINPAGE + "Lang=E&ReturnUrl=" + returnURL;
            window.top.location.href = url;
          } else if (action == "logout") {
            alert("If you are using HKJC Web Services in other browser windows, they will also be logged out. Please close those browser windows if needed.");
            url = window.globalConfig?.LINKED_PAGES?.LOGOUTPAGE + "&Lang=E&ReturnUrl=" + returnURL;
            window.top.location.href = url;
          } else if (action == "register") {
            url = window.globalConfig?.LINKED_PAGES?.REGISTERPAGE + "&Lang=E";
            window.top.location.href = url;
          } else if (action == "preference") {
            url = window.globalConfig?.LINKED_PAGES?.PREFERENCEPAGE + "&Lang=E&ReturnUrl=" + returnURL;
            window.top.location.href = url;
          } else if (action == "help") {
            window.open(window.globalConfig?.LINKED_PAGES?.FAQPAGEENG);
          }
        } else {
          if (action == "login") {
            url = window.globalConfig?.LINKED_PAGES?.LOGINPAGE + "Lang=C&ReturnUrl=" + returnURL;
            window.top.location.href = url;
          } else if (action == "logout") {
            alert("如你正在其他視窗開啟馬會網上服務，該等服務亦會同時被登出，如有需要請關閉該等視窗。");
            url = window.globalConfig?.LINKED_PAGES?.LOGOUTPAGE + "&Lang=C&ReturnUrl=" + returnURL;
            window.top.location.href = url;
          } else if (action == "register") {
            url = window.globalConfig?.LINKED_PAGES?.REGISTERPAGE + "&Lang=C";
            window.top.location.href = url;
          } else if (action == "preference") {
            url = window.globalConfig?.LINKED_PAGES?.PREFERENCEPAGE + "&Lang=C&ReturnUrl=" + returnURL;
            window.top.location.href = url;
          } else if (action == "help") {
            window.open(window.globalConfig?.LINKED_PAGES?.FAQPAGECHI);
          }
        }
      }
    }
  }

  export const getLoginInfo= (custProIn: any, langType: string) => {

    const custProInList = getCookie(custProIn)
    let isLogin = false;
    let displayName = ""
    console.log("custProIn 1", custProIn, custProInList)
    //setIsLogin(false);
    if (getLastName(custProIn) != null) {
      //setIsLogin(true);
      isLogin = true;
      displayName = langType === LANGTYPE_EN ? 
        showDisplayNameEN(getDisplayName(custProInList), getSalutation(custProInList), getLastName(custProInList), getLastNameChinese(custProInList)) : 
        showDisplayNameCH(getDisplayName(custProInList), getSalutation(custProInList), getLastName(custProInList), getLastNameChinese(custProInList))
      //setShowDisplayName(displayName);  
    }
    return{isLogin, displayName}
    
  
    function getCookie(name: string) {
      // var nameEQ = name + "=";
      // var ca = document.cookie.split(';'); 
      // let d = "";
      const h = ":";
      // for (var i = 0; i < ca.length; i++) {
      //   var c = ca[i];
  
      //   while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      //   console.log("ssssss  2",c)
      //   if (c.indexOf(nameEQ) == 0)
      //   { console.log("ssssss  2",nameEQ.length, c.length ,  c.substring(nameEQ.length, c.length)); 
      //    d = c.substring(nameEQ.length, c.length); break}    
      // }
      // console.log("ssssss",d)
      let a = [];
      if (name != null) {
        a = name.split(h);
        return a
      }
      return [];
    }
  
    function E(a: any[], n: number) {
      if (a?.[n] != null) {
        return decodeURIComponent(a[n].replace(/\+/g, "%20"))
      } else {
        return null
      }
    }
  
    function getDisplayName(a: any[]) {
      return E(a, 0)
    } 
    function getSalutation(a: any[]) {
      return E(a, 1)
    }
    function getLastName(a: any[]) {
      return E(a, 2)
    }
    function getLastNameChinese(a: any[]) {
      return E(a, 3)
    } 
    function showDisplayNameCH(displayname: string|null, salutation: string|null, lastname: string|null, lastnamechinese: string|null) {
      var showname = displayname;
      if (salutation == "Mr." || salutation == "Mr")
        salutation = "先生";
  
      if (salutation == "Ms." || salutation == "Ms")
        salutation = "女仕";
  
      if (salutation == "Miss." || salutation == "Miss")
        salutation = "小姐";
  
      if (salutation == "Mrs." || salutation == "Mrs")
        salutation = "太太";
  
      if (displayname == "" || displayname == null) {
  
        if (lastnamechinese == "" || lastnamechinese == null)
          showname = (lastname ?? "") + (salutation ?? "");
        else
          showname = lastnamechinese + salutation;
      }
  
      var name = "    " + showname + "    ";
      return name;
    }
  
    function showDisplayNameEN(displayname: string|null, salutation: string|null, lastname: string|null, lastnamechinese: string|null) {
      var showname = displayname;
      if (salutation == "先生")
        salutation = "Mr";
  
      if (salutation == "女士")
        salutation = "Ms";
  
      if (salutation == "小姐")
        salutation = "Miss";
  
      if (salutation == "太太")
        salutation = "Mrs";
  
      if (displayname == "" || displayname == null)
        showname = salutation + "." + lastname;
  
      var name = "    " + showname + "    ";
      return name;
    }
  }
const sanitizeInput = (input?: string) => {
  // Basic sanitation to remove potentially harmful characters
  return input?.replace(/[<>%]/g, ''); // Example: remove <, >, and %
};
export const switchLanguage = (lang: LangCode) => {
    const currentPath = window.location.pathname;
    const pathParts = currentPath.split("/");
    if ([LANGCODE_EN, LANGCODE_CT].includes(pathParts[1])) {
      pathParts[1] = lang;
      const newPath = pathParts.splice(0, pathParts.length).join("/");
      window.location.href = generateUrl(newPath, {'b_cid': ''}, true, true, lang);
    }
  };
  
  export const generateUrl = (newPathname?: string, queries?: { [key: string]: string | undefined }, keepQuery?: boolean, isExternal: boolean = false, langCodeToChange?: LangCode) => {
    if (newPathname) {
      newPathname = sanitizeInput(newPathname); // Sanitize the pathname
    }
  
    const path = newPathname?.split("?")?.[0];
    const searchPart = newPathname?.split("?")?.[1];
    let params = new URLSearchParams(keepQuery ? window?.location?.search : searchPart);
    // sanitation & set param
    // For generating external url, don't apply case insensitive on url query
    const paramsObj = {...(isExternal ? Object.fromEntries(params.entries()) : getSearchParams(params)), ...queries} // queries value will override current params if it is duplicated
    params = new URLSearchParams(paramsObj)
    for (const key in paramsObj) {
      if (paramsObj[key]) {
        params.set(key, sanitizeInput(paramsObj[key]?.toString()) || '');
      } else {
        params.delete(key);
      }
    }
    if (isExternal) {
      return decodeURIComponent(`${path || window.location.pathname}${params.toString() ? "?" + params.toString() : ''}`)
    }
    const langCode = langCodeToChange || window.location.pathname?.split("/")?.[1] || "en-us"
    return decodeURIComponent(`${path ? "/" + langCode + "/overseas" + path : window.location.pathname}${params.toString() ? "?" + params.toString() : ''}`)
  }

const queriesMapping: {[key: string]: string} = {
    racedate: "racedate",
    racecourse: "racecourse",
    raceno: "raceno",
    season: "season",
    view: "view"
};
  
// return search params in case-insensitive
export const getSearchParams = (searchParams: ReadonlyURLSearchParams | URLSearchParams) => {
    let result: any = {};
    Array.from(searchParams.entries()).forEach(([key, value]) => {
        let mappedKey = key.toLowerCase();
        if (queriesMapping[mappedKey]) {
          mappedKey = queriesMapping[mappedKey]
        }
        result[mappedKey] = value;
    });
    return result;
  }
  

export const openTarget = (target?: string | null) => {
    return target ? (["01-NewPage", "_blank"].includes(target || '') ? "_blank" : "_self") : undefined;
  };

export const openNewWindow = (newwindow: String | null) => {
    return newwindow === "1" ? "_blank" : "_self";
  };
  
export const setRouting = (newPathname?: string, queries?: { [key: string]: string | undefined }, curState?: any) => {
    const curUrl = window.location.href
    const host = window.location.host
    const newUrl = generateUrl(newPathname, queries, true);
    console.log('route generate', newUrl, queries)
    if (curUrl.slice(curUrl.indexOf(host) + host.length) != newUrl) {
      console.log('route update', curUrl, newUrl)
      window.history.pushState({ prePath: curUrl }, '', newUrl);
    }
} 

export const updateMetaTag = (lang: string, page: string) => {
  console.log('updateMetaTag', lang, page);
  document.title = getMetaTitle(lang, page);
  //document.querySelectorAll('meta[name="description"], meta[name="keywords"]')?.forEach(e => e?.setAttribute("content", getMetaKeywords(lang, page)));
  
  // update og tag
  //document.querySelectorAll('meta[property="og:title"], meta[name="twitter:title"]')?.forEach(e => e?.setAttribute("content", getMetaTitle(lang, page)));
  //document.querySelectorAll('meta[property="og:description"], meta[name="twitter:description"]')?.forEach(e => e?.setAttribute("content", getMetaKeywords(lang, page)));
  //document.querySelectorAll('meta[property="og:image"], meta[name="twitter:image"]')?.forEach(e => e?.setAttribute("content", getMetaImage(lang, page)));
}

export const formattedNumber = (value: number) => {
  const newFormattedNumber = new Intl.NumberFormat("en-us", {
    style: "decimal",
    currency: "USD",
  }).format(value);
  return newFormattedNumber;
};

export const displayText = (text: string) => {
  if (text != null && text != "") {
    return text
  }
  else {
    return '-'
  }
}

// public static int MapFOStage(XElement xMtg, XElement xFOPl, IEnumerable<XElement> xPMPls)
//         {
//             string mtgStatus = xMtg.GetAttr("Dtl", "st");
//             string fopStatus = xFOPl.GetAttrVal("st");
//             //var fopOdds = xFOPl.GetElements("Odds>Cmb");
//             return !string.IsNullOrEmpty(fopStatus) ?  //fopOdds.Any() ?
//                         ("CLOSED".PoolState().Contains(fopStatus) || xFOPl.GetAttrVal("concl").ToBool() ? 6                       // JKC or TNC Pool Closed
//                         : "Started".Equals(mtgStatus) ? 5                                   // Inplay
//                         //: "SellingStarted".Equals(fopStatus) ? 4  // Confirm StartSell      //fopOdds.All(x => !"Initial".Equals(x.GetAttrVal("cmbSt"))
//                         : 4)                                                                // FO Defined + Before StartSell      //  Odds Available  (Stage 3 - Reference Odds Available Deprecated)
//                     : xPMPls.SelectMany(x => x.GetElements("Odds>Full>Cmb")).Any() ? 2      // Win Odds Available
//                     : "DECLARED".MeetingState().Contains(mtgStatus) ? 1                     // Meeting Declared
//                     : 0;
//         }

const MapFOStage = (commonMeetings: any, oddsType: string) => {
  const mtgStatus = commonMeetings?.status;
  const fopStatus = commonMeetings?.foPools?.find((i:any) => i.oddsType == oddsType)?.status;
  const isConcluded = commonMeetings?.foPools?.find((i:any) => i.oddsType == oddsType)?.isConcluded;
  const hasCombs = commonMeetings?.pmPools?.filter((i:any) => i.hasCombs).length > 0;
  return fopStatus ? (PoolState('CLOSED').includes(fopStatus) || isConcluded ? 6
        : mtgStatus.toUpperCase() == "STARTED" ? 5 
        : 4 ) :  hasCombs ? 2 
        : MeetingState("DECLARED").includes(mtgStatus) ? 1 
        : 0;
}

export const MeetingState = (type:string) => {
  switch (type.toUpperCase())
  {
      case "INITIAL":
          return ["INITIAL", "DRAFT", "ENTRY", "DECLARED", "DEFINED", "STARTED", "CLOSED", "ABANDON", "ABANDON_PARTIAL", "ENTRY_ABANDON" ]
      case "ENTRY":
          return ["ENTRY", "DECLARED", "DEFINED", "STARTED", "CLOSED", "ABANDON", "ABANDON_PARTIAL", "ENTRY_ABANDON"];
      case "DECLARED":
          return ["DECLARED", "DEFINED", "STARTED", "CLOSED", "ABANDON", "ABANDON_PARTIAL"];
      case "DEFINED":
          return ["DEFINED", "STARTED", "CLOSED", "ABANDON", "ABANDON_PARTIAL"];
      case "STARTED":
          return ["STARTED", "CLOSED", "ABANDON", "ABANDON_PARTIAL"];
      case "CLOSED":
          return ["CLOSED", "ABANDON", "ABANDON_PARTIAL"];
      case "ABANDON":
          return ["ABANDON", "ENTRY_ABANDON"];
      case "RACECARD":
          return ["DECLARED", "DEFINED", "STARTED"];
      default:
          return [];
  };
}

export const PoolState = (type:string) => {
    switch (type)
    {
        case "DEFINED":
            return ["DEFINED", "INITIAL"];
        case "STARTSELL":
            return [ "STARTSELL", "STOPSELL"];    //, "PAYOUT" };
        case "REMOVED":
            return ["REMOVED"];
        case "SUSPEND":
            return ["SUSPENDED", "REFUNDBEFORESUSPEND"];
        case "REFUND":
            //return ["REFUND", "REFUNDBEFORESUSPEND", "REFUNDAFTERSUSPEND", "CLOSEDAFTERREFUND", "REFUNDAFTERCLOSE", "REFUNDBEFORECLOSE", "REFUNDAFTERDEFINED", "REFUNDAFTERRESULT"];
            return ["REFUND", "REFUNDBEFORESUSPEND", "REFUND", "REFUNDBEFORESUSPEND", "REFUNDAFTERSUSPEND", "CLOSEDAFTERREFUND", "REFUNDAFTERCLOSE", "REFUNDBEFORECLOSE", "REFUNDAFTERDEFINED", "REFUNDAFTERRESULT"]    
        case "CLOSED":
            return ["CLOSED", "RESULT", "PAYOUTSTARTED", "PAYOUTSTOPPED", "PAYOUTHOLD", "PAYOUT", "STOPPAY", "REFUND", "REFUNDBEFORESUSPEND", "CLOSEDAFTERREFUND", "REFUNDAFTERCLOSE", "REFUNDBEFORECLOSE", "REFUNDAFTERDEFINED", "REFUNDAFTERRESULT"];
        case "PAYOUT":
            return ["PAYOUTSTARTED", "PAYOUTSTOPPED", "PAYOUTHOLD", "PAYOUT", "STOPPAY", "REFUND", "REFUNDBEFORESUSPEND", "CLOSEDAFTERREFUND", "REFUNDAFTERCLOSE", "REFUNDBEFORECLOSE", "REFUNDAFTERDEFINED", "REFUNDAFTERRESULT"]; //, "CLOSED" };

        default:
            return [];
    };
}

export const RaceState = (type: string) => {
  switch (type) {
    case "CLOSED":
      return ["CLOSED", "RESULT", "VOIDED", "ABANDONED"];
    case "RESULT":
      return ["Partial", "Completed", "Official", "FullFieldPlacing", "WCFullMargin"];
    case "REFUND":
      return ["VOIDED", "ABANDONED"];
    default:
      return [];
  };
}

export const getFOStageResult = async (date: any, oddsType: string) => {
  const res = await getFOStage(date);
  let stage = 0;
  if (res?.commonMeetings?.[0]) {
    stage = MapFOStage(res?.commonMeetings?.[0], oddsType)
  }
  return stage
}

export const getAssetPrefix = () => process.env.NEXT_PUBLIC_WITH_PREFIX === 'Y' ? '/local/informationAsset' : '';

export const getCurrentTimeFormatted = () => {
  const now = new Date();
  
  const day = String(now.getDate()).padStart(2, '0'); 
  const month = String(now.getMonth() + 1).padStart(2, '0'); 
  const year = now.getFullYear(); 
  const hours = String(now.getHours()).padStart(2, '0'); 
  const minutes = String(now.getMinutes()).padStart(2, '0'); 

  return `${day}/${month}/${year} ${hours}:${minutes}`;
}

export const adobeData = (lang: "en-us" | "zh-hk" | "zh-cn", type: "pageview" | "interaction", data: WAData) => {
  // Refer to: https://deopconf01.corp.hkjc.com/display/RWWS/JCRW+Simulcast+Implementation+Guide
  
setTimeout(() => {
  const adobeData = {
    "event": type,
    "page": {
      "name": data.pageUrl,
      "id": data.pageId,
      "language": lang,
    },
    "user": {
      "cuno": window?.WCIPCookie?.getCuno(),
      "customer_segment": window?.WCIPCookie?.getCustomerSegment(),
    },
    "content": {
      "horse": data.horse || "",
      "race_no": data.raceNo || "",
    },
    "interaction": {
      "sorting": data.sorting || "",
      "event_id": type === 'pageview' ? '' : data.eventId || "",
      "button_name": data.buttonName || "",
      "video_filename": data.videoFileName || "",
      "content_title": data.contentTitle || "",
      "video_source": data.videoSource || "",
      "download_filename": data.downloadFileName || ""
    },
    "report_suite": "",
    "internal_ad": decodeURIComponent(data.internalAd || new URLSearchParams(window.location.search).get('b_cid') || ""),
  }
  const isEU = window?.GBGdpr?.isEU?.();
  console.log('trigger adobeData', adobeData, 'isEU', isEU);
  window?.adobeDataLayer?.push({
    "event": "watracking",
    "IsEU": isEU,
  });
  window?.adobeDataLayer?.push(adobeData);
}, 1000); 
}


export const getDayDisplay = (date:any, lang:any) => {
  const Day = new Date(date).getDay();
  const isEn = lang == "en-us";
  const dayMap = [
    isEn ? "Sun": "星期日",
    isEn ? "Mon": "星期一",
    isEn ? "Tue": "星期二",
    isEn ? "Wed": "星期三",
    isEn ? "Thu": "星期四",
    isEn ? "Fri": "星期五",
    isEn ? "Sat": "星期六",
  ]
  return dayMap[Day];
}

export const getDBLPoolNo = (number:any, lang:any) => {
  const isEn = lang == "en-us";
  return isEn ? numberToEnglish(number) :numberToChinese(number);
}
function numberToChinese(num:any) {
  const chineseNumbers = ["", "一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
  
  if (num <= 10) {
      return chineseNumbers[num]; // 1 到 9
  } else if (num == 10) {
      return chineseNumbers[10]; // 10
  } else if (num < 20) {
      return "十" + (num % 10 == 0 ? "" : chineseNumbers[num % 10]); // 11 到 19
  } else if (num == 20) {
      return "二十"; // 20
  } else if (num < 30) {
      return "二十" + (num % 10 == 0 ? "" : chineseNumbers[num % 10]); // 21 到 29
  } else if (num == 30) {
      return "三十"; // 30
  } else if (num < 40) {
      return "三十" + (num % 10 == 0 ? "" : chineseNumbers[num % 10]); // 31 到 39
  } else if (num == 40) {
      return "四十"; // 40
  } else if (num < 50) {
      return "四十" + (num % 10 == 0 ? "" : chineseNumbers[num % 10]); // 41 到 49
  } else {
      return "五十"; // 50
  }
}

function numberToEnglish(num:any) {
  switch (num.toString()) {
    case '1':
      return "1ST";
    case '2':
      return "2ND";
    case '3':
      return "3RD";
    default:
      return `${num}TH`;
  }
}
export const paddingNum = (value: Number | number | string, minimumIntegerDigits: number = 2) => {
  switch (typeof value) {
    case 'object':
    case 'number':
      return value.toLocaleString('en-us', { minimumIntegerDigits: minimumIntegerDigits, useGrouping: false })
    case 'string':
      if (!isNaN(Number(value)))
        return Number(value).toLocaleString('en-us', { minimumIntegerDigits: minimumIntegerDigits, useGrouping: false })
  }
  return 0
}

export const getCmsDomain = () => {
  return window.globalConfig?.DATA_SOURCES?.CMS_DOMAIN;
};

export const getJcbwDomain = () => {
  return window.globalConfig?.DATA_SOURCES?.JCBW_DOMAIN;
};

export const isUrlExisted = async (url: string) => {
  let controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), window.globalConfig?.OTHERS?.CHECKEXIST_TIMEOUT || 10000);
  return !url ? false : await fetch(url, { method: "HEAD", cache: "no-store", signal: controller.signal, redirect: 'manual' })
    .then((res) => { return res.url.replace(/https:|http:/g, '') == url.replace(/https:|http:/g, '') && [200, 302].includes(res.status) })
    .catch((err) => {
      console.log('isUrlExisted----', err)
      return false
    });
};

export const mapRaceClassList = (mtg: any) => {

    const RaceClassList = mtg?.races?.map((race: any) => {
      const raceVoid = RaceState("REFUND").includes(race?.status?.toUpperCase());
      // RaceState("RESULT").includes(race.status) [race.status]  => RaRes
      const resultInd = RaceState("RESULT").includes(race?.status?.toUpperCase()) || "RESULT" == race?.status?.toUpperCase();
      const mp = mtg?.pmPools?.filter((x: any) => Number(x.leg.races?.[0] ?? 0) == Number(race.no ?? 0))?.find((x: any) => PoolState("REFUND").includes(x.status?.replaceAll("_", "")));

      return {
        status: race.status,
        raceNo: race.no,
        AbandonInd: raceVoid ? MapAbandonRaceInd(race?.status?.toUpperCase()) : (!resultInd && mp) ? 1 : 0
      }
    })
    return RaceClassList;
  }
export const MapAbandonRaceInd = (raSt: string) => {
  return "ABANDONED" == raSt ? 2 : "VOIDED" == raSt ? 1 : 0;
}